import { fetchLoadSimpleTestResult } from "api/inspect";
import InspectListItems from "components/inspect/items/inspect.list.items";
import { InspectParams, SimpleTestResult } from "interface/interface.inspect";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InspectResultListWrapper } from "style/inspect";

const InspectResultList = () => {
  const [data, setData] = useState<SimpleTestResult[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const authStateRaw = localStorage.getItem("authState");

    if (!authStateRaw) return; // ✅ 아예 없으면 로그인 안 된 상태
    const auth = JSON.parse(authStateRaw);

    if (!auth?.isAuthenticated) return; // ✅ 로그인 되어 있지 않으면 중단

    const loadInspectResultList = async () => {
      try {
        const params: InspectParams = {
          orderBy: "REGDT",
          orderByDir: "DESC",
        };
        const response = await fetchLoadSimpleTestResult(params);
        if (response.result) setData(response.result);
      } catch (error) {
        console.error(error);
      }
    };

    loadInspectResultList();
  }, []);

  const simpleTestClicked = () => {
    navigate("/inspect/simple/step");
  };

  return (
    <InspectResultListWrapper>
      <InspectListItems data={data} />
    </InspectResultListWrapper>
  );
};

export default InspectResultList;
